import React, { FunctionComponent, memo } from 'react';
import { Box, Grid, Typography, Checkbox } from '@material-ui/core';
import Image from 'material-ui-image';
import IFeature from '../../../../../../model/IFeature';
import OptionUnavailable from '../../../../../../../common/assets/images/optionUnavailable.png';
import checkboxOptionStyles from './checkboxOptionStyles';
import ConfigurablePrice from '../../../../../presentational/prices/configurablePrice/ConfigurablePrice';

export interface ICheckboxOptionProps {
  feature: IFeature;
  isChecked: boolean;
  handleChange: (_event: any) => void;
  value: string;
}

const CheckboxOption: FunctionComponent<ICheckboxOptionProps> = memo(({ feature, isChecked, handleChange, value }) => {
  const styles = checkboxOptionStyles();

  return (
    <Grid item={true} xs={6} className={styles.gridContainer}>
      <Box
        data-test={`option:${feature.code}`}
        className={styles.itemContainer}
        onClick={() => handleChange(feature.code)}
      >
        <Image
          key={feature.images[0]?.url}
          src={feature.images[0]?.url || 'error'}
          alt={feature.name}
          animationDuration={0}
          color={'transparent'}
          aspectRatio={1.5}
          data-test={'option:image'}
          errorIcon={
            <img src={OptionUnavailable} className={styles.imageUnavailable} data-test={'image:vehicle:unavailable'} />
          }
          className={styles.imageContainer}
        />
        <Box className={styles.detailsContainer}>
          <Typography component="p" variant="caption" data-test={`option:${feature.name}`}>
            {feature.name}
          </Typography>
          <ConfigurablePrice prices={feature.prices} display={{ showOrLabel: false }} />
        </Box>
        <Box className={styles.selectionContainer}>
          <Checkbox
            checked={isChecked}
            value={value}
            size={'medium'}
            color={'primary'}
            data-test={`option:type:checkbox`}
            data-selected={`${isChecked}`}
          />
        </Box>
      </Box>
    </Grid>
  );
});

export default CheckboxOption;
